import actionTypes from "../../actionTypes";

export const deleteCertificateLoaderAction = (data) => ({
  type: actionTypes.adminTypes.certificateManagementTypes
    .DELETE_CERTIFICATE_LOADER,
  payload: data,
});
export const uploadCertificateLoaderAction = (data) => ({
  type: actionTypes.adminTypes.certificateManagementTypes
    .UPLOAD_CERTIFICATE_LOADER,
  payload: data,
});
export const postNewCertificateLoaderAction = (data) => ({
  type: actionTypes.adminTypes.certificateManagementTypes
    .POST_NEW_CERTIFICATE_LOADER,
  payload: data,
});
export const postEditCertificateLoaderAction = (data) => ({
  type: actionTypes.adminTypes.certificateManagementTypes
    .POST_EDIT_CERTIFICATE_LOADER,
  payload: data,
});
